import React, { useState, useEffect } from 'react';
import {IProps, IState, IMessageKey} from './types';
import * as S from './styles';
import RemoveIcon from '@assets/icons/removeIcon';
import ErrorIcon from '@assets/icons/errorIcon';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import C from '@assets/themes/colors';

const Snackbar:React.FC<IProps> = (props) => {

  const [messages, setMessages] = useState<IMessageKey[]>([]);
  const [nextKey, setNextKey] = useState(1);
  const [removeMessage, setRemoveMessage] = useState<number | undefined>();
  const defaultDisplayTime = 6000;

  useEffect(() => {
    if (props.message && props.message.value !== "") {
      var newMessages: IMessageKey[] = messages;
      newMessages = [...newMessages, { message: props.message, key: nextKey }];
      setMessages(newMessages);
      setTimeout(function(){ setRemoveMessage(nextKey); if (props.setHideCloseIcon) { props.setHideCloseIcon(false);} },props.message.displaytime??defaultDisplayTime);
      setNextKey(nextKey+1);
    }
  }, [props.message])

  useEffect(() => {
    if (removeMessage) {
      handleRemove(removeMessage);
    }
  }, [removeMessage])

  const handleRemove = (key?: number) => {
    if (key && messages.length > 0) {
      let index = messages.map((message) => { return message.key}).indexOf(key);
      if (index !== -1) {
        var newMessages: IMessageKey[] = messages;
        newMessages=[
          ...newMessages.slice(0,index),
          ...newMessages.slice(index + 1)
        ];
        setMessages(newMessages);
      }
    }
  }

  return (
    <S.Root key={messages ? messages.length : 0} >
      <TransitionGroup className="group-snack-list">
        {
          messages && messages.length > 0 &&
          messages.map((messagekey) => {
            return (
              <CSSTransition key={messagekey.message.value} timeout={600} classNames="item">
                <S.SnackbarBox key={messagekey.key} style={props.style} >
                  <S.IconContainer>
                    {
                      messagekey.message.type === "success" &&
                      <BlackCheckIcon/>
                    }
                    {
                      messagekey.message.type === "error" &&
                      <ErrorIcon />
                    }
                  </S.IconContainer>
                  <S.MessageContainer>
                    {messagekey.message.value}
                  </S.MessageContainer>
                  {
                    !props.hideCloseIcon && 
                    <S.ActionContainer onClick={() => handleRemove(messagekey.key)} >
                      <RemoveIcon fillColor={C.WHITE} />
                    </S.ActionContainer>
                  }
                </S.SnackbarBox>
              </CSSTransition>
            )
          })
        }
      </TransitionGroup>
    </S.Root>
  );
}

export default Snackbar;